import { delete_document } from "../../utils/endpoints";

export default function DocumentDelete({
  document_info,
  loadAttachmentList,
  context,
}) {
  const handleDelete = async () => {
    let response = await context.httpRequest(
      "delete",
      delete_document.replace("*", document_info[0].attachment.id),
      null,
      context.session.token
    );

    if (response.result) {
      context.openMessage(
        "success",
        "Il documento è stato eliminato correttamente"
      );
      loadAttachmentList();
      document.querySelector("#close-modal-button").click();
    }
  };

  return (
    <>
      <div className="w-75 text-center mx-auto">
        <strong className="d-block">
          Confermi di voler eliminare il documento selezionato?
        </strong>
        <span className="mt-3 mb-4 d-block">
          Questa è un operazione irreversibile e non potrai recuperarlo una
          volta eliminata.
        </span>
      </div>
      <button
        className="q8-blue-button p-3 w-100"
        onClick={() => handleDelete()}
      >
        ELIMINA DOCUMENTO
      </button>
    </>
  );
}
